import React from 'react';
import { Box, Text, TextButton, Button } from '@wix/design-system';
import { Add } from '@wix/wix-ui-icons-common';
export const EmptyBrandkit = props => {
  const {
    addNewButtonOnClick,
    skipButtonOnClick,
    skipButton,
    addNewButton,
    emptyStateText,
    refreshButton,
    showAddButton,
    areControlsDisabled
  } = props;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "12px",
    direction: "vertical",
    width: "100%",
    padding: 0
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, emptyStateText), /*#__PURE__*/React.createElement(Box, {
    gap: "18px",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    onClick: skipButtonOnClick,
    disabled: areControlsDisabled
  }, skipButton.label), showAddButton ? /*#__PURE__*/React.createElement(TextButton, {
    disabled: areControlsDisabled,
    size: "tiny",
    prefixIcon: /*#__PURE__*/React.createElement(Add, null),
    onClick: addNewButtonOnClick
  }, addNewButton.label) : refreshButton));
};
//# sourceMappingURL=EmptyBrandkit.js.map